import React from 'react'
import { useForm, usePage } from '@inertiajs/inertia-react'
import Layout from '../../Shared/Layout/LayoutAdmin'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { SIA_GOLD_ACTIVE_BG, SIA_GOLD_ACTIVE_TEXT, SIA_NAVY } from '../../constants/siaTheme'

const ForcePasswordChange = ({ user }) => {
    const { errors: pageErrors } = usePage().props
    const form = useForm({
        current_password: '',
        password: '',
        password_confirmation: '',
    })

    const fieldError = (key) => {
        const e = form.errors[key] || pageErrors?.[key]
        return Array.isArray(e) ? e[0] : e
    }

    const submit = (e) => {
        e.preventDefault()
        form.post(route('password.force.update'), { preserveScroll: true })
    }

    return (
        <div className="d-flex justify-content-center px-2 pb-10 mt-5">
            <div
                className="w-100 rounded-3 shadow-sm bg-white overflow-hidden"
                style={{ maxWidth: '560px', border: '1px solid #e8e8e8' }}
            >
                <div className="text-center text-white py-5 px-4" style={{ backgroundColor: SIA_NAVY }}>
                    <div className="text-uppercase fw-semibold opacity-75 mb-1" style={{ letterSpacing: '0.08em' }}>
                        Primer acceso
                    </div>
                    <div className="fw-bold fs-3">Cambiar contraseña</div>
                </div>

                <div className="px-6 px-md-10 py-8">
                    <p className="text-gray-700 fs-5 lh-lg mb-2">
                        Hola {user.name}. Antes de continuar debes definir una contraseña nueva.
                    </p>
                    <p className="text-gray-600 mb-6">
                        Mínimo 8 caracteres y distinta a la temporal que te entregaron. Correo: {user.email}
                    </p>

                    <div className="rounded-3 p-5 mb-6" style={{ backgroundColor: '#fbf6e8', border: '1px solid #e6d48a' }}>
                        <div className="fw-semibold mb-1" style={{ color: '#8a7014' }}>Obligatorio</div>
                        <p className="mb-0 text-gray-800">
                            No puedes usar el resto del sistema hasta guardar la nueva contraseña. Si sales y vuelves a
                            entrar, se te pedirá de nuevo.
                        </p>
                    </div>

                    <Form onSubmit={submit}>
                        <Form.Group className="mb-4">
                            <Form.Label className="fw-bold">Contraseña temporal</Form.Label>
                            <Form.Control
                                type="password"
                                autoComplete="current-password"
                                value={form.data.current_password}
                                onChange={(e) => form.setData('current_password', e.target.value)}
                                isInvalid={Boolean(fieldError('current_password'))}
                                required
                            />
                            {fieldError('current_password') && (
                                <div className="invalid-feedback d-block">{fieldError('current_password')}</div>
                            )}
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label className="fw-bold">Nueva contraseña</Form.Label>
                            <Form.Control
                                type="password"
                                autoComplete="new-password"
                                value={form.data.password}
                                onChange={(e) => form.setData('password', e.target.value)}
                                isInvalid={Boolean(fieldError('password'))}
                                required
                                minLength={8}
                            />
                            {fieldError('password') && <div className="invalid-feedback d-block">{fieldError('password')}</div>}
                        </Form.Group>

                        <Form.Group className="mb-6">
                            <Form.Label className="fw-bold">Confirmar nueva contraseña</Form.Label>
                            <Form.Control
                                type="password"
                                autoComplete="new-password"
                                value={form.data.password_confirmation}
                                onChange={(e) => form.setData('password_confirmation', e.target.value)}
                                isInvalid={Boolean(fieldError('password_confirmation'))}
                                required
                                minLength={8}
                            />
                            {fieldError('password_confirmation') && (
                                <div className="invalid-feedback d-block">{fieldError('password_confirmation')}</div>
                            )}
                        </Form.Group>

                        <div className="d-flex flex-wrap gap-3">
                            <Button
                                type="submit"
                                className="fw-semibold px-6"
                                disabled={form.processing}
                                style={{
                                    backgroundColor: SIA_GOLD_ACTIVE_BG,
                                    color: SIA_GOLD_ACTIVE_TEXT,
                                    border: 'none',
                                }}
                            >
                                Guardar y continuar
                            </Button>
                            <Button
                                type="button"
                                variant="light"
                                onClick={(e) => {
                                    e.preventDefault()
                                    document.getElementById('logout-form')?.submit()
                                }}
                            >
                                Cerrar sesión
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )
}

ForcePasswordChange.layout = (page) => <Layout title="Cambiar contraseña">{page}</Layout>

export default ForcePasswordChange
